export default {
    partnerTypes(state) {
        return state.partnerTypes;
    },
    user(state) {
        return state.user;
    },
    loadingBaseData(state) {
        return state.loadingBaseData;
    },
    editingUser(state) {
        return state.editingUser;
    }
};